module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "id": "sort"
    }
  }, [_c('div', {
    staticClass: "radio-group"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('city.mealType')))]), _vm._v(" "), _vm._l((_vm.filtersOptions.mealType), function(option) {
    return _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filtersData.mealType),
        expression: "filtersData.mealType"
      }],
      attrs: {
        "type": "radio",
        "name": "mealType",
        "id": 'mealType-' + option.value
      },
      domProps: {
        "value": option.value,
        "checked": _vm._q(_vm.filtersData.mealType, option.value)
      },
      on: {
        "change": [function($event) {
          _vm.$set(_vm.filtersData, "mealType", option.value)
        }, _vm.sort]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'mealType-' + option.value
      }
    }, [_vm._v(_vm._s(option.text))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "radio-group"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('city.mealType')))]), _vm._v(" "), _vm._l((_vm.filtersOptions.difficulty), function(option) {
    return _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filtersData.difficulty),
        expression: "filtersData.difficulty"
      }],
      attrs: {
        "type": "radio",
        "name": "difficulty",
        "id": 'difficulty-' + option.value
      },
      domProps: {
        "value": option.value,
        "checked": _vm._q(_vm.filtersData.difficulty, option.value)
      },
      on: {
        "change": [function($event) {
          _vm.$set(_vm.filtersData, "difficulty", option.value)
        }, _vm.sort]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'difficulty-' + option.value
      }
    }, [_vm._v(_vm._s(option.text))])])
  })], 2)]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "recipes"
    }
  }, [_vm._l((_vm.recipes), function(recipe) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'recipe',
          params: {
            city: _vm.city.url,
            recipe: recipe.url
          }
        }
      }
    }, [_c('span', {
      staticClass: "img-wrap"
    }, [_c('img', {
      attrs: {
        "src": _vm.$options.filters.formatUrl(recipe.image.url),
        "alt": recipe.name
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "content"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(recipe.name))]), _vm._v(" "), _c('span', {
      staticClass: "description"
    }, [_vm._v(_vm._s(_vm._f("recipeDescription")(recipe.description)))]), _vm._v(" "), _c('button', {
      attrs: {
        "type": "button",
        "name": "button"
      }
    }, [_vm._v("voir la recette")])])])], 1)
  }), _vm._v(" "), (_vm.recipes.length <= 0) ? _c('p', {
    staticClass: "no-recipe"
  }, [_vm._v("\n      Aucun recette ne correspond à la selection\n    ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "pie",
      "data-parallax": "2"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1618336c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/City.vue
// module id = 66
// module chunks = 1